import { useState } from "react";
import { PackagePlus } from "lucide-react";
import { Button } from "../../shared/ui/Button";
import { Card } from "../../shared/ui/Card";
import { useShop, useShopActions } from "./useShop";
export function ShopAdminPanel() {
  const query = useShop(),
    actions = useShopActions();
  const [name, setName] = useState(""),
    [description, setDescription] = useState(""),
    [points, setPoints] = useState(200),
    [stock, setStock] = useState(10),
    [emoji, setEmoji] = useState("🎁");
  if (!query.data) return null;
  return (
    <section className="shop-panel">
      <div className="section-divider">
        <span>商城治理</span>
        <h2>商品与库存</h2>
      </div>
      <div className="management-grid">
        <Card className="management-card">
          <div className="card-heading">
            <PackagePlus />
            <div>
              <span>总部专属</span>
              <h2>新增兑换商品</h2>
            </div>
          </div>
          <div className="v4-form">
            <div className="form-split">
              <label className="v4-field">
                <span>商品名称</span>
                <input value={name} onChange={(e) => setName(e.target.value)} />
              </label>
              <label className="v4-field">
                <span>图标</span>
                <input
                  value={emoji}
                  onChange={(e) => setEmoji(e.target.value)}
                />
              </label>
            </div>
            <label className="v4-field">
              <span>商品说明</span>
              <input
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </label>
            <div className="form-split">
              <label className="v4-field">
                <span>星能价格</span>
                <input
                  type="number"
                  value={points}
                  onChange={(e) => setPoints(Number(e.target.value))}
                />
              </label>
              <label className="v4-field">
                <span>初始库存</span>
                <input
                  type="number"
                  value={stock}
                  onChange={(e) => setStock(Number(e.target.value))}
                />
              </label>
            </div>
            <Button
              disabled={
                actions.pending ||
                !name.trim() ||
                !description.trim() ||
                points <= 0 ||
                stock < 0
              }
              onClick={() =>
                actions.createProduct({
                  name: name.trim(),
                  description: description.trim(),
                  points,
                  stock,
                  imageEmoji: emoji,
                })
              }
            >
              <PackagePlus size={15} />
              上架商品
            </Button>
          </div>
        </Card>
        <Card className="management-card energy-rules">
          {query.data.products.map((p) => (
            <article key={p.id}>
              <span>{p.imageEmoji}</span>
              <div>
                <strong>{p.name}</strong>
                <p>{p.description}</p>
              </div>
              <b>
                {p.points} · 库存{p.stock}
              </b>
            </article>
          ))}
        </Card>
      </div>
    </section>
  );
}
